import React from "react";
import {LexemePageContext} from "./LexemePageContext";
import {Button} from 'react-bootstrap';
import {LexemeDictionaryType} from "./parts/00_DictionaryType/LexemeDictionaryType";
import {LexemeTitle} from "./parts/01_Title/LexemeTitle";
import {LexemeData} from "./parts/02_Data/LexemeData";
import {LexemeSubentries} from "./parts/03_Subentries/LexemeSubentries";
import {LexemeGeneralPhrases} from "./parts/03_Subentries/parts/LexemeGeneralPhrases";
import {LexemePolyrhematics} from "./parts/04_Polyrhematics/LexemePolyrhematics";
import {LexemeReferences} from "./parts/05_References/LexemeReferences";
import BUtils, {isMobile} from "../../utilities/BaseUtilities";
import stylesLexemePage from '../../_css/dictionary/lexemePage.module.css';
import {LexemeDisplayContext, LexemePageInfos, LexemeUtilities} from "./editor/LexemeHelper";
import {LexemePlace} from "./parts/06_Place/LexemePlace";
import {changeTab, getPage, getTabIndex, getTabs, setPage} from "./LexemePage";
import {LexemeShiftButtons} from "./LexemeShiftButtons";
import {LexemeDescrLanguage} from "./LexemeDescrLanguage";
import {AdministrationUtilities} from "../../administration/AdministrationHelper";
import {LexemePhrase} from "./parts/03_Subentries/parts/LexemePhrase";

export class LexemaPageContextProvider extends React.Component {
    constructor(props) {
        super(props);

        this.dictType = this.props.page.dictionary_properties.type;
        this.tabIndex = getTabIndex();
        this.isMobile = BUtils.isMobile();
    }

    static getDerivedStateFromError(error) {
        return {isOK: false};
    }

    componentDidMount() {
        const idPostFix = this.props.idPostFix;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        var contextonte = LexemePageInfos.createContext(this.props.pageStatus, this.props.displayContext, this.props.page, this.props.callBackSelectionHandler, this.props.startItem, this.props.textToAdd, this.props.descrLanguage, this.props.classType, this.props.sharedOptions, this.props.host, undefined);
        return contextonte;
    }

    getContext() {
        const module = AdministrationUtilities.getModuleByPathName(window.location.pathname);
        return LexemePageInfos.createContext(this.props.pageStatus, this.props.displayContext, this.props.page, this.props.callBackSelectionHandler, this.props.startItem, this.props.textToAdd, this.props.descrLanguage, this.props.classType, this.props.sharedOptions, this.props.host, module);
    }

    render() {
        const idPostFix = this.props.idPostFix;
        const pageStatus = this.props.pageStatus;
        const page = this.props.page;
        const displayContext = this.props.displayContext;
        const isAlternativeForm = typeof this.props.page.title.main_form !== 'undefined';
        const isExport = this.props.displayContext === 'EXPORT';
        const excludeBody = isAlternativeForm && isExport;
        const isSelector = pageStatus.endsWith('_SELECTOR');
        const isTreeModel = this.props.page.lexeme_properties.is_tree_model;
        const isEncyclopedic = AdministrationUtilities.isEncyclopedic();
        const showDictionaryType = !isEncyclopedic && (!isTreeModel || isSelector) && displayContext === LexemeDisplayContext.DICTIONARY_SEARCH;
        const isToponym = this.props.page.lexeme_properties.discriminator === 'TOPONYM';
        const isExternalDict = this.props.page.isExternalDict;
        const host = this.props.host;
        // baddi const phraseAsGeneral = pageStatus === 'READ_ONLY_EXTERNAL_CREATE' ? this.props.page.lexeme_properties.general_phrase_at_first_sense : AdministrationUtilities.phrasesAsGeneral(this.getContext());
        const phraseAsGeneral = this.props.page.lexeme_properties.general_phrase_at_first_sense;

        return <LexemePageContext.Provider key={'lexeme-provi-' + idPostFix} value={this.getContext()}>
            {showDictionaryType ?
                <LexemeDictionaryType key='lexeme-dictionary-type' page={page} isMobile={this.isMobile}
                                      pageStatus={pageStatus}/> : ''}
            {!isSelector && !isExport && !isExternalDict ?
                <LexemeShiftButtons dictType={this.props.page.dictionary_properties.type}
                                    idPostFix={this.props.idPostFix}/> : ''}
            {pageStatus !== 'READ_ONLY' && pageStatus !== 'READ_ONLY_CREATE' && pageStatus !== 'READ_ONLY_EXTERNAL_CREATE' && pageStatus !== 'EXTERNAL_DICTIONARY_SELECTOR' ?
                <LexemeDescrLanguage/> : ''}
            <div className={BUtils.joinClasses('lexeme-page', 'lexeme-page-no-dictype--' + !showDictionaryType)}>
                 <LexemeTitle key={'lexeme-title-' + idPostFix} displayContext={displayContext} page={page} pageStatus={pageStatus}/>
                {!excludeBody ? <div id={'dictionary-body-' + page.lexeme_properties.root_entry_id}
                     className={BUtils.joinClasses(stylesLexemePage['dictionary-body'], stylesLexemePage['scrollable-dict-contents'], 'dictionary-body')}
                     style={{
                         borderBottom: !window.location.pathname.startsWith('/lexeme') ? '1px solid #dddddd' : '',
                         height: (isSelector || this.isMobile ? 'auto' : (document.getElementById("lexeme-page-container").offsetHeight - 140) + "px")
                     }}>
                    { /*!isEncyclopedic ||*/ true ? <LexemeData key={'lexeme-data-' + idPostFix} page={page} pageStatus={pageStatus}/> : '' }
                    {isToponym ? <LexemePlace key={'lexeme-place-' + idPostFix} page={page}/> : <>
                        <LexemeSubentries key={'subentries-' + idPostFix} page={page} pageStatus={pageStatus}/>
                        {phraseAsGeneral ? <LexemeGeneralPhrases page={page}/> : ''}
                        <LexemePolyrhematics key={'polyrhematics-' + idPostFix} page={page} pageStatus={pageStatus}
                                             displayContext={displayContext}/></>}
                    <LexemeReferences key={'references-' + idPostFix} direct={true} page={page}
                                      pageStatus={pageStatus}/>
                    <LexemeReferences key={'inverse-references-' + idPostFix} direct={false} page={page}
                                      pageStatus={pageStatus}/>
                </div> : ''}
            </div>
        </LexemePageContext.Provider>
    }
}